module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa2_m.452949316e0310654e5b973475b1ddba.png";